import actions from "@/store/modules/category/actions";
import mutations from "@/store/modules/category/mutations";
import state from "@/store/modules/category/state";

export default {
    actions,
    mutations,
    state
}